import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Information(props) {
    return (
        <SvgIcon {...props}>
            <path d="M17 12c-.2 0-.4 0-.6-.1-.2-.1-.3-.2-.5-.3-.1-.1-.2-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.2 0-.4.1-.6.1-.2.2-.3.3-.5.1-.1.3-.2.5-.3.2-.1.4-.1.6-.1.2 0 .4 0 .6.1.2.1.3.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.3.4-.1.1-.3.2-.5.3-.2.1-.4.1-.6.1zm-1.2 10.1c-.6 0-1-.2-1.4-.5-.4-.4-.6-.9-.6-1.6 0-.3 0-.7.1-1.2l1.2-5.8h2.6l-1.3 6.1c0 .2-.1.3-.1.6 0 .2.1.4.2.5.1.1.3.1.6.1.2 0 .3 0 .5-.1s.3-.2.5-.3c.3-.3.5-.7.7-1.1h.8c-.3.9-.7 1.6-1.2 2.2-.4.4-.9.8-1.4.9-.4.1-.8.2-1.2.2zM16 30C8.3 30 2 23.7 2 16S8.3 2 16 2s14 6.3 14 14-6.3 14-14 14zm0-26C9.4 4 4 9.4 4 16s5.4 12 12 12 12-5.4 12-12S22.6 4 16 4z" />
        </SvgIcon>
    );
}

Information.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Information;
